module.exports = __webpack_public_path__ + "media/images/undraw_reviewed_docs-affd4789bc275c7192cf3f86906adea6.png";